import { Box, Tooltip, Typography } from "@mui/material";
import { Flex } from "Components/_Shared/Core/Flex";
import { ReactComponent as InfoIcon } from "Components/_Shared/Icons/Assets/info.svg";
import type { AllocatedAmount } from "Infrastructure/ApiZfp/Schema";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { formatCurrencyWithoutCode } from "Infrastructure/Utils/CurrencyUtils";

type Props = {
  allocatedAssetAmounts: AllocatedAmount[];
};

export const GoalFulfillmentItemFundsTooltip = ({ allocatedAssetAmounts }: Props) => {
  const { t } = useResource();

  if (allocatedAssetAmounts.length === 0) return null;

  return (
    <Tooltip
      title={
        <Box>
          {allocatedAssetAmounts.map((item, index) => (
            <Flex justifyContent="space-between" gap={Spacing.L} key={`${item.labels?.name ?? "item"}-${index}`}>
              <Typography variant="caption" color="grey.300">
                {item.labels?.name}
              </Typography>
              <Flex gap={Spacing.XS}>
                <Typography variant="caption" color="grey.50">
                  {formatCurrencyWithoutCode(item.amount?.value)}
                </Typography>
                <Typography variant="caption" color="grey.50">
                  {t(Resources.Common.CZKSuffix)}
                </Typography>
              </Flex>
            </Flex>
          ))}
        </Box>
      }
    >
      <Flex alignItems="center" pl={Spacing.S} sx={{ cursor: "pointer", color: "grey.500", "&:hover": { color: "grey.800" } }}>
        <InfoIcon width={"16px"} color="currentColor" />
      </Flex>
    </Tooltip>
  );
};
